import React  from 'react'
import { GetSentEmailHistory } from '../../../api/services/pms';
import DropDown from '../dropdown';
import moment from 'moment'
import { dateTimeFormat } from '../constants';

const SendEmailHistoryDropDown = ({...rest}) => {
    return <DropDown api={GetSentEmailHistory} textField="Subject" valueField="Id" labelField={item=>{
        return moment(item.CreateDate).format(dateTimeFormat)
    }} descriptionField={item=>{
        return <span style={{padding: "0.5833em 0.833em"}}>{item.To}</span>
    }} {...rest}/> 
}

export default SendEmailHistoryDropDown